export function getRandomNumber(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

export function formatThousands(value: string | number, sep = "٬") {
  const normalizedValue = removeSeparator(String(value))

  const groupRegex = /([0-9\u06F0-\u06F9\u0660-\u0669])(?=([0-9\u06F0-\u06F9\u0660-\u0669]{3})+(?![0-9\u06F0-\u06F9\u0660-\u0669]))/g

  return normalizedValue.replace(/\d+|[۰-۹]+|[٠-٩]+/g, (val) => {
    return val.replace(groupRegex, `$1${sep}`)
  })
}

export function removeSeparator(value: string) {
  if (!value) return value
  return value.replace(/[٬,. ]/g, "")
}
